import type { QueryArgFrom } from '../rtk-query-types';
import type { AnyApi } from '../buildCreateApi';
import type { GetStoreFn } from '../types';
import type { AnyQueryDefinition, AnyEndpointQuery } from './types';

type SubscribeOptions = {
    /**
     * Флаг, который позволяет сделать запрос даже в том случае, если в кеше есть данные.
     */
    forceRefetch?: boolean;
};

// Набор дополнительных методов эндпоинта, которые добавляются в RTK Query.
export type EndpointSubscribe<Definition extends AnyQueryDefinition> = {
    /**
     * @soft-deprecated Метод скоро будет удален. Используйте endpoint.query()
     */
    subscribe: (queryArgs: QueryArgFrom<Definition>, options?: SubscribeOptions) => () => void;
};

// Параметры для `buildEndpointMutate()`.
type BuildQueryOptions = {
    api: AnyApi;
    endpointName: string;
    getStore: GetStoreFn;
};

export function buildEndpointSubscribe({
    api,
    endpointName,
    getStore,
}: BuildQueryOptions): EndpointSubscribe<AnyQueryDefinition>['subscribe'] {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    const endpoint = api.endpoints[endpointName] as AnyEndpointQuery;

    return function subscribe(queryArgs, options) {
        const promise = getStore().dispatch(
            endpoint.initiate(queryArgs, {
                forceRefetch: options?.forceRefetch,
            })
        );

        return () => promise.unsubscribe();
    };
}
